import { useState, useEffect } from 'react';
import { useWallet } from '../contexts/WalletContext';

export const useWalletFavorites = () => {
  const { isConnected } = useWallet();
  const [favoriteWallets, setFavoriteWallets] = useState(new Set());

  // Load favorites from localStorage
  useEffect(() => {
    const savedFavorites = localStorage.getItem('favoriteWallets');
    if (savedFavorites) {
      try {
        const favoritesArray = JSON.parse(savedFavorites);
        setFavoriteWallets(new Set(favoritesArray));
      } catch (error) {
        console.error('Error loading wallet favorites:', error);
      }
    }
  }, []);

  // Toggle favorite status for wallets
  const toggleWalletFavorite = (walletId, walletData = null) => {
    if (!isConnected) {
      console.warn('Please connect your wallet to favorite other wallets');
      return false;
    }

    setFavoriteWallets(prev => {
      const newFavorites = new Set(prev);
      if (newFavorites.has(walletId)) {
        newFavorites.delete(walletId);
        // Remove from saved creators if it exists
        if (walletData) {
          const savedCreators = JSON.parse(localStorage.getItem('savedCreators') || '[]');
          const updatedCreators = savedCreators.filter(creator => creator.id !== walletId);
          localStorage.setItem('savedCreators', JSON.stringify(updatedCreators));
        }
      } else {
        newFavorites.add(walletId);
        // Save creator data if provided
        if (walletData) {
          const savedCreators = JSON.parse(localStorage.getItem('savedCreators') || '[]');
          const existingIndex = savedCreators.findIndex(creator => creator.id === walletId);
          if (existingIndex === -1) {
            savedCreators.push(walletData);
            localStorage.setItem('savedCreators', JSON.stringify(savedCreators));
          }
        }
      }
      
      // Save to localStorage
      localStorage.setItem('favoriteWallets', JSON.stringify([...newFavorites]));
      return newFavorites;
    });
    
    return true;
  };

  // Check if a wallet is favorited
  const isWalletFavorited = (walletId) => {
    return favoriteWallets.has(walletId);
  };

  // Get all favorite wallet IDs
  const getFavoriteWalletIds = () => {
    return [...favoriteWallets];
  };

  return {
    favoriteWallets,
    toggleWalletFavorite,
    isWalletFavorited,
    getFavoriteWalletIds,
    isConnected
  };
};
